var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"canvas-container",attrs:{"id":"ScheduleAchievementBarGraph"}},[_c('canvas',{ref:"barGraphCanvas",staticClass:"barGraph-canvas",attrs:{"id":"reportBarGraph","height":_vm.monthReportGraphHeight - 28,"width":_vm.CANVAS_WIDTH}})])
}
var staticRenderFns = []

export { render, staticRenderFns }